import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export const ProductsPage = ({ addToCart }) => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAllActiveProducts = async () => {
      try {
        setIsLoading(true);
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/product/active`
        );
        const list = res.data?.data || [];
        setProducts(list);
      } catch (err) {
        console.error("Error fetching active products:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAllActiveProducts();
  }, []);

  return (
    <>
      <div
        className="full-row bg-light overlay-dark py-5"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/banner.png)`,
          backgroundPosition: "center center",
          backgroundSize: "cover",
        }}
      >
        <div className="container">
          <div className="row text-center text-white">
            <div className="col-12">
              <h3 className="mb-2 text-white font-weight-bold">
                All Products
              </h3>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center bg-transparent">
                  <li className="breadcrumb-item">
                    <a href="/" className="text-white">
                      Home
                    </a>
                  </li>
                  <li
                    className="breadcrumb-item active text-white"
                    aria-current="page"
                  >
                    All Products
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <section
        className="products"
        style={{ maxWidth: "1350px", margin: "auto", paddingTop: "30px" }}
      >
        <div className="container">
          {isLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-success" role="status" />
            </div>
          ) : products.length === 0 ? (
            <div className="text-center py-5">No products found.</div>
          ) : (
            <div className="row">
              {products.map((x) => {
                let benifits = [];
                try {
                  const raw = x?.benefits || x?.benifits;
                  benifits = raw ? (typeof raw === "string" ? JSON.parse(raw) : raw) : [];
                } catch {
                  benifits = [];
                }

                return (
                  <div className="col-12 col-md-6 col-lg-4 mb-4" key={x?.id}>
                    <div
                      className="card"
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`/product/${x?.slug}`)}
                    >
                      <h3 className="product-title text-center">{x?.name}</h3>
                      <div className="product-wrapper d-flex flex-column flex-md-row">
                        <div className="col-12 col-md-6 benefits-section">
                          <ul className="list-group">
                            {Array.isArray(benifits) &&
                              benifits.map((b, i) => (
                                <li className="list-group-item" key={i}>
                                  <i className="fa-solid fa-check"></i> {b}
                                </li>
                              ))}
                          </ul>
                        </div>
                        <div className="col-12 col-md-6 product-image">
                          <img
                            src={
                              x?.image?.startsWith("http")
                                ? x.image
                                : `${process.env.REACT_APP_ASSET_URL}/${x?.image}`
                            }
                            alt={x?.name}
                          />
                        </div>
                      </div>
                      <div className="product-price my-2 text-center">
                        <strong>Retail Price:</strong> ₹ {x?.currentPrice}
                      </div>
                      <div className="text-center mb-3 px-3">
                        <button
                          className="btn btn-success w-100"
                          onClick={(e) => {
                            e.stopPropagation();
                            addToCart({ ProductId: x?.id, quantity: 1 });
                          }}
                        >
                          Order Now
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </>
  );
};
